import * as React from "react";
import { RadiosEditor } from "../../../../react-core/Html/RadiosEditor";
import { DistributionDividendPreference } from "../../../../Wrap/Constants/Enums/Domain/DistributionDividendPreference";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";
import { SectionHeader } from "../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { checkPermission } from "../../Permission/PermissionHelper";
import { IProcessComponentProps, ProcessComponent } from "../../Process/Process/ProcessComponent";
import { manageIncomeOptionsMap, ProcessType } from "../Resource/Content";

interface IManageIncomeProps extends IProcessComponentProps {
    type: ProcessType;
    clAccountId: string;
}

interface IManageIncomeState {}

export class ManageIncome extends ProcessComponent<IManageIncomeProps, IManageIncomeState> {
    constructor(props: IManageIncomeProps) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        if (!this.props.data?.DistributionDividendPreference)
            {this.props.onChange({ DistributionDividendPreference: DistributionDividendPreference.Reinvest });}
    }

    render() {
        const { type, onChange, data } = this.props;
        return (
            <>
                {SectionHeader("Manage income")}
                <RadiosEditor
                    cssWrapper="control-size-430 mb-30 rg-inline"
                    selected={data?.DistributionDividendPreference}
                    options={Object.keys(manageIncomeOptionsMap).map((ele) => Number(ele))}
                    onChange={(v) => onChange({ DistributionDividendPreference: v })}
                    required={"Please select"}
                    getText={(v) => manageIncomeOptionsMap[v]}
                />
                {this.props.clAccountId && checkPermission(UserClaim.AdviserPortalDluManageIncomeCanView) && (
                    <a href={"/clients/cash/manageincome.aspx?claccountid=" + this.props.clAccountId} target="_blank">
                        Link to change: Manage Income
                    </a>
                )}
            </>
        );
    }
}
